export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sseWorker.worker.076293b8.worker.js");
}
